"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = void 0;
const sum = (arr, selector = (x) => x) => {
    return arr
        .filter(Boolean)
        .map(selector)
        .reduce((total, item) => total + (typeof item === 'number' ? item : 0), 0);
};
exports.sum = sum;
